import { createAction } from 'redux-actions-helpers'
import { MapType } from './types'
import { CourseType } from '../CoursePage/types'

export const fetchMap = createAction(
  '@@admin-map-edit/FETCH_MAP',
  (id: string): any => ({ id })
)

export const fetchMapSuccess = createAction(
  '@@admin-map-edit/FETCH_MAP_SUCCESS',
  (result: MapType): any => ({ result })
)

export const fetchMapFailure = createAction(
  '@@admin-map-edit/FETCH_MAP_FAILURE',
  (error: string): any => ({ error })
)

export const fetchCourse = createAction(
  '@@admin-map-edit/FETCH_COURSE',
  (id: string): any => ({ id })
)

export const fetchCourseSuccess = createAction(
  '@@admin-map-edit/FETCH_COURSE_SUCCESS',
  (result: CourseType): any => ({ result })
)

export const fetchCourseFailure = createAction(
  '@@admin-map-edit/FETCH_COURSE_FAILURE',
  (error: string): any => ({ error })
)

export const editMap = createAction(
  '@@admin-map-edit/EDIT_MAP',
  (
    map_id: string,
    course_id: string,
    image: File,
    is_active: boolean
  ): any => ({ map_id, course_id, image, is_active })
)

export const editMapSuccess = createAction(
  '@@admin-map-edit/EDIT_MAP_SUCCESS',
  (result: any): any => ({ result })
)

export const editMapFailure = createAction(
  '@@admin-map-edit/EDIT_MAP_FAILURE',
  (error: string): any => ({ error })
)

export const createMarker = createAction(
  '@@admin-map-edit/CREATE_MARKER',
  (
    map_id: string,
    typeMarker: string,
    position_x: number,
    position_y: number,
    module_lesson_id: string
  ): any => ({
    map_id,
    typeMarker,
    position_x,
    position_y,
    module_lesson_id,
  })
)

export const createMarkerSuccess = createAction(
  '@@admin-map-edit/CREATE_MARKER_SUCCESS'
)

export const createMarkerFailure = createAction(
  '@@admin-map-edit/CREATE_MARKER_FAILURE',
  (error: string): any => ({ error })
)

export const editMarker = createAction(
  '@@admin-map-edit/EDIT_MARKER',
  (
    map_id: string,
    marker_id: string,
    typeMarker?: string,
    position_x?: number,
    position_y?: number,
    module_lesson_id?: string
  ): any => ({
    map_id,
    marker_id,
    typeMarker,
    position_x,
    position_y,
    module_lesson_id,
  })
)

export const editMarkerSuccess = createAction(
  '@@admin-map-edit/EDIT_MARKER_SUCCESS'
)

export const editMarkerFailure = createAction(
  '@@admin-map-edit/EDIT_MARKER_FAILURE',
  (error: string): any => ({ error })
)

export const removeMarker = createAction(
  '@@admin-map-edit/REMOVE_MARKER',
  (map_id: string, marker_id: string): any => ({
    map_id,
    marker_id,
  })
)

export const removeMarkerSuccess = createAction(
  '@@admin-map-edit/REMOVE_MARKER_SUCCESS'
)

export const removeMarkerFailure = createAction(
  '@@admin-map-edit/REMOVE_MARKER_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-map-edit/DESTROY')
